import { IPredefinedTheme } from "../../Themes";
import img1 from "./screenshot.png";

export const Theme: IPredefinedTheme = {
  name: "Warmer",
  credit: "hexnaught",
  description: "Warmer, softer theme",
  reference: "https://discord.com/channels/415207508303544321/921991895230611466/921999581020028938",
  screenshot: img1,
  colors: {
    primarylight: "#EA9062",
    primary: "#DD7B4A",
    primarydark: "#D3591C",
    successlight: "#6ACF6A",
    success: "#43BF43",
    successdark: "#3E913E",
    errorlight: "#C15757",
    error: "#B34141",
    errordark: "#752525",
    secondarylight: "#AAA",
    secondary: "#888",
    secondarydark: "#666",
    warninglight: "#E6E69D",
    warning: "#DADA56",
    warningdark: "#A1A106",
    infolight: "#69f",
    info: "#36c",
    infodark: "#039",
    welllight: "#444",
    well: "#222",
    white: "#fff",
    black: "#000",
    hp: "#dd3434",
    money: "#ffd700",
    hack: "#adff2f",
    combat: "#faffdf",
    cha: "#AD84CF",
    int: "#6495ed",
    rep: "#faffdf",
    disabled: "#76C6B7",
    backgroundprimary: "#000",
    backgroundsecondary: "#000",
    button: "#333",
  },
};
